import { isEconomiaUser } from './EconomiaUserDetect'

export const init = () => {
	if (location.hostname !== 'www.funnygardening.com') {
		let scriptTag = document.createElement('script')
		scriptTag.setAttribute('src', 'https://cdn.performax.cz/yi/openwrap/openwrap_4244_others.js')
		scriptTag.setAttribute('defer', 'defer')
		document.body.appendChild(scriptTag)

		if (isEconomiaUser()) {
			window.__pxPageConfig = window.__pxPageConfig || {}
			window.__pxPageConfig.template = 'ET'
		}
	}

	let scriptTag3 = document.createElement('script')
	scriptTag3.setAttribute('src', 'https://cdn.performax.cz/yi/adsbypx/px_autoads.js')
	scriptTag3.setAttribute('defer', 'defer')
	document.body.appendChild(scriptTag3)

	let styleTag = document.createElement('link')
	styleTag.setAttribute('href', 'https://cdn.performax.cz/yi/adsbypx/px_autoads.css')
	styleTag.setAttribute('rel', 'stylesheet')
	document.head.appendChild(styleTag)
}

export const placePXBranding = () => {
	const pageWrap = document.querySelector('.page-wrap')
	const leaderboard = document.querySelector('.leaderboard-banner')

	document.querySelector('body').classList.add('branding-enabled', 'branding-enabled--px')
	leaderboard.classList.add('px-ads', 'px-ads--leaderboard')
	leaderboard.querySelector('.ratio').classList.remove('ratio', 'ratio-97x30')

	const fragment = document.createDocumentFragment(leaderboard)
	fragment.appendChild(document.querySelector('.leaderboard-banner'))

	pageWrap.parentNode.insertBefore(fragment, pageWrap)
	pageWrap.classList.add('px-main-content')

	leaderboard.classList.remove('leaderboard-banner')
}
